import { type JSX } from 'react'
import { FormText } from './FormText.js'

interface Props {
  name: string
  label: string
  helpText?: string
  placeholder?: string
  autoFocus?: boolean
  disabled?: boolean
  required?: boolean
}

/**
 * FormPassword — thin wrapper around FormText with type="password".
 *
 * Use this instead of `<FormText type="password" />` so password fields are
 * grep-able and so we can later swap in a show/hide toggle in one place.
 */
export function FormPassword(props: Props): JSX.Element {
  return <FormText {...props} type="password" />
}
